import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getSocket } from "../utils/socket";

export default function useSocket() {
  const socket = getSocket();

  const [socketConnect, setSocketConnect] = useState(
    socket?.connected || false,
  );

  const userId = useSelector(({ Auth }) => Auth?.user?._id);

  useEffect(() => {
    const onConnect = () => {
      if (userId) {
        if (socket._loggedConnectedId !== socket.id) {
          socket._loggedConnectedId = socket.id;
          console.info("✅ socket connected:", socket.id);
        }
        setSocketConnect(true);
        const isAlreadyRegistered =
          socket._registeredSocketId === socket.id &&
          socket._registeredUserId === userId;
        const isCurrentlyRegistering =
          socket._registeringSocketId === socket.id &&
          socket._registeringUserId === userId;

        if (!isAlreadyRegistered && !isCurrentlyRegistering) {
          socket._registeringSocketId = socket.id;
          socket._registeringUserId = userId;

          socket.emit("usersocket", { userId }, (ack) => {
            console.info("📩 usersocket ack:", ack);

            if (ack?.status === "success" || ack?.success) {
              console.info("✅ usersocket registered");
              socket._registeredSocketId = socket.id;
              socket._registeredUserId = userId;
            } else {
              console.error("❌ usersocket registration failed");
              socket._registeringSocketId = null;
              socket._registeringUserId = null;
            }
          });
        }
      }
    };

    const onDisconnect = (reason) => {
      if (socket._loggedDisconnectedId !== socket.id) {
        socket._loggedDisconnectedId = socket.id;
        console.info("❌ socket disconnected:", reason);
      }
      setSocketConnect(false);
      socket._registeredSocketId = null;
      socket._registeredUserId = null;
      socket._registeringSocketId = null;
      socket._registeringUserId = null;
      socket._loggedConnectedId = null;
    };

    const onConnectError = (err) => {
      if (socket._loggedErrorId !== socket.id) {
        socket._loggedErrorId = socket.id;
        console.error("🚨 socket connect_error:", err?.message);
      }
      socket._registeringSocketId = null;
      socket._registeringUserId = null;
    };

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    socket.on("connect_error", onConnectError);

    if (userId) {
      if (socket.connected) {
        onConnect();
      } else if (!socket.active) {
        socket.connect();
      }
    } else {
      if (socket.connected || socket.active) {
        socket.disconnect();
      }
    }

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("connect_error", onConnectError);
    };
  }, [userId]);

  return {
    socket,
    socketConnect,
  };
}
